import { ref } from 'vue';
import { defineStore } from 'pinia';
import { getCurrentUserCollections } from '@/services';
import type { CollectionModel } from '@/models';
import { useAccountStore } from './account';

export const useCollectionStore = defineStore('collection', () => {
  const accountStore = useAccountStore();

  const collections = ref<CollectionModel[]>([]);

  async function loadCollections(forceReload: boolean = false) {
    if (!accountStore.hasCurrentAccount) {
      console.log(`${loadCollections.name}: No current account selected`);
      return;
    }

    if (collections.value.length === 0 || forceReload) {
      collections.value = await getCurrentUserCollections();
    }
  }

  return {
    collections,
    loadCollections,
  }
})
